<template>
  <div class="breadcrumbs" itemscope itemtype="http://schema.org/BreadcrumbList">
    <span
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
      data-test-id="list__breadcrumb"
    >
      <MMLink to="/" itemprop="item">
        <MMText font="Body M/Regular" color="tertiary" itemprop="name">Главная</MMText>
      </MMLink>
      <meta itemprop="position" :content="'1'" />
    </span>

    <template v-for="(crumb, index) in categories" :key="crumb.id">
      <MMText tag="span" font="Body M/Regular" color="tertiary">/</MMText>
      <span
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
        data-test-id="list__breadcrumb"
      >
        <MMLink :to="categoryURL(crumb)">
          <MMText font="Body M/Regular" color="tertiary" itemprop="name">{{ crumb.title }}</MMText>
        </MMLink>
        <meta itemprop="position" :content="String(index + 2)" />
      </span>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { TSkuCategory } from '../../mappers/product-to-categories';
import { MMLink, MMText } from '@mm-frontend/mm-web-ui-kit';

// Temporary function
const categoryURL = (category: TSkuCategory) => {
  return `/category/${category.id}`;
};

interface Props {
  categories: TSkuCategory[];
}

defineProps<Props>();
</script>

<style lang="stylus" scoped>
.breadcrumbs
  font-size: 16px;
  padding 8px 16px
  white-space nowrap
  overflow-x scroll
  padding-bottom 20px
  display flex
  gap 8px
</style>
